import React from 'react';
import { CommonPageStep } from '..';
import { Button } from '@mui/material';
import { setAppPageStep } from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export interface NotFoundElementInterface {
  backHomeButton: JSX.Element;
  sadCodyIcon: JSX.Element;
}

export const NotFoundElement = (): NotFoundElementInterface => {
  // ELEMENT FUNCTIONS

  // ELEMENT

  const sadCodyIcon = (
    <React.Fragment>
      <img
        id="login-main-back-button"
        alt=""
        src="assets/common/sad-cody.png"
        onClick={() => {}}
      />
    </React.Fragment>
  );

  const backHomeButton = (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        style={{ marginTop: '32px' }}
        disabled={false}
        onClick={async () => {
          outsideComponentDispatch(setAppPageStep(CommonPageStep.LOGIN));
        }}
      >
        Back to Home
      </Button>
    </React.Fragment>
  );

  return {
    sadCodyIcon,
    backHomeButton,
  };
};
